// extracted by mini-css-extract-plugin
var _1 = "FPVU36xb3Dg21g1dnimW";
var _2 = "bMLEmOunGxNKV5Yh9b7T";
export { _1 as "contentProfile", _2 as "mainProfile" }
